import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const BucketStats = ({ stats }) => {
    const isLoading = !stats;

    return (
        <Row className="mb-4">
            <Col md={3}>
                <div style={{ boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }}>
                    <Card className="text-center p-3">
                        <h2>{isLoading ? <Skeleton /> : stats.bucketCount}</h2>
                        <p>Total Buckets</p>
                    </Card>
                </div>
            </Col>
            <Col md={3}>
                <div style={{ boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }}>
                    <Card className="text-center p-3">
                        <h2>{isLoading ? <Skeleton /> : stats.totalStaff}</h2>
                        <p>Total Staff</p>
                    </Card>
                </div>
            </Col>
            <Col md={3}>
                <div style={{ boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }}>
                    <Card className="text-center p-3">
                        <h2>{isLoading ? <Skeleton /> : stats.totalStaff - stats.staffWithoutBucket}</h2>
                        <p>Staff in Buckets</p>
                    </Card>
                </div>
            </Col>
            <Col md={3}>
                <div style={{ boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }}>
                    <Card className="text-center p-3">
                        <h2>{isLoading ? <Skeleton /> : stats.staffWithoutBucket}</h2>
                        <p>Unassigned Staff</p>
                    </Card>
                </div>
            </Col>
        </Row>
    );
};

export default BucketStats;
